import { useState } from 'react'
import { Tabs, Typography } from 'antd'
import { FileSearchOutlined, SplitCellsOutlined, FieldTimeOutlined } from '@ant-design/icons'
import '../../../styles/aurora-page.css'
import '../../../styles/aurora-modal.css'
import JsonToolboxTab from './JsonToolboxTab'
import DiffTab from './DiffTab'
import TimeCronTab from './TimeCronTab'

const { Title } = Typography

/** 报文调试主页面：接口测试的周边刚需，内置三个页签模块（Mock 服务由系统既有 Mock 服务承担） */
export default function PayloadDebug() {
  const [activeKey, setActiveKey] = useState('json')

  return (
    <div className="aurora-page aurora-page--fit">
      {/* ① 页头 */}
      <div className="page-header">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Title level={4} style={{ margin: 0, fontWeight: 600 }}>报文调试</Title>
        </div>
      </div>

      {/* ② 主内容卡片：三页签内嵌（与「数据构造」页结构统一） */}
      <div className="content-card">
        <Tabs
          activeKey={activeKey}
          onChange={setActiveKey}
          tabBarStyle={{ paddingLeft: 22 }}
          items={[
            {
              key: 'json',
              label: (
                <span><FileSearchOutlined /> JSON 工具箱</span>
              ),
              children: <JsonToolboxTab />,
            },
            {
              key: 'diff',
              label: (
                <span><SplitCellsOutlined /> 文本/JSON Diff</span>
              ),
              children: <DiffTab />,
            },
            {
              key: 'time-cron',
              label: (
                <span><FieldTimeOutlined /> 时间戳与 cron</span>
              ),
              children: <TimeCronTab />,
            },
          ]}
        />
      </div>
    </div>
  )
}
